import { render, staticRenderFns } from "./ResidentAdd.vue?vue&type=template&id=51ac46d2&scoped=true"
import script from "./ResidentAdd.vue?vue&type=script&lang=js"
export * from "./ResidentAdd.vue?vue&type=script&lang=js"
import style0 from "./ResidentAdd.vue?vue&type=style&index=0&id=51ac46d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ac46d2",
  null
  
)

export default component.exports